module.exports = __webpack_public_path__ + "img/img3.c6e07677.svg";